// Scripts for Access to Action page

(function ($, Drupal) {
  //Initialize the parallax library for ATA page
  if ($('.page-access-to-action').length > 0) {
    jarallax(document.querySelectorAll(".jarallax"), {
      imgPosition: 'center'
    });
  }
})(jQuery, Drupal);
